// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/4/2023
 */

.NestedTable_tableContainer__xM4jV {
    height: max-content;
    width: 100%;
    justify-content: center;
    background-color: white;
   margin-right: -20px;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.NestedTable_tRow__QJsB1 {
    display: flex;
    justify-content: space-between;
}

.NestedTable_tCell__KD8XA {
    border-bottom: none;
    display: flex;
    align-items: center;
}

.NestedTable_line__tbmcH {
    border-top: 0.1px solid #e0e0e0;
}`, "",{"version":3,"sources":["webpack://./src/Components/Category/NestedTable.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,uBAAuB;GACxB,mBAAmB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;AACnC","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 3/4/2023\r\n */\r\n\r\n.tableContainer {\r\n    height: max-content;\r\n    width: 100%;\r\n    justify-content: center;\r\n    background-color: white;\r\n   margin-right: -20px;\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.tRow {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.tCell {\r\n    border-bottom: none;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.line {\r\n    border-top: 0.1px solid #e0e0e0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `NestedTable_tableContainer__xM4jV`,
	"tRow": `NestedTable_tRow__QJsB1`,
	"tCell": `NestedTable_tCell__KD8XA`,
	"line": `NestedTable_line__tbmcH`
};
export default ___CSS_LOADER_EXPORT___;
